import { parseUnknownDate } from './parseUnknownDate'

export const getTimeFromDate = (date: string): number => parseUnknownDate(date)?.getTime() ?? 0
